import React, { useEffect, useState } from 'react'
import investorTokenAssetsService, {
  InvestorTokenAsset,
  InvestorTokenAssetStatus,
} from 'Services/investorTokenAssetsService'
import { CurrencyFormatter } from 'Helpers'

interface TdlaInvestmentsTableProps {
  pageNumber: number
  pageSize: number
  status: InvestorTokenAssetStatus
  onTotalChange: (total: number) => void
}

const TdlaInvestmentsTable: React.FC<TdlaInvestmentsTableProps> = ({
  pageNumber,
  pageSize,
  status,
  onTotalChange,
}) => {
  const [assets, setAssets] = useState<InvestorTokenAsset[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    const fetchTdlaAssets = async () => {
      try {
        setIsLoading(true)
        const res = await investorTokenAssetsService.list({
          pageNumber,
          pageSize,
          sortOrder: 'DESC',
          status,
        })
        if (cancelled) return

        const { dataset, total } = res.data.data
        setAssets(dataset ?? [])
        onTotalChange(total ?? 0)
      } catch {
        if (!cancelled) {
          setAssets([])
          onTotalChange(0)
        }
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }
    fetchTdlaAssets()
    return () => {
      cancelled = true
    }
  }, [pageNumber, pageSize, status])

  return (
    <div className='bx-table-wrapper'>
      <table className='bx-table'>
        <thead>
          <tr>
            <th className='bx-finance__col-index'>#</th>
            <th className='bx-finance__col-investor'>Investor</th>
            <th className='bx-finance__col-amount'>Amount</th>
            <th className='bx-finance__col-date'>Investment Date</th>
            <th className='bx-finance__col-reference'>Next Due Date</th>
            <th className='bx-finance__col-status'>Status</th>
            <th className='bx-finance__col-pool'>Pool</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={7} className='bx-finance__empty'>
                Loading...
              </td>
            </tr>
          ) : assets.length ? (
            assets.map((asset, index) => {
              const offset = (pageNumber - 1) * pageSize
              return (
                <tr key={asset.id}>
                  <td className='bx-finance__col-index'>{offset + index + 1}</td>
                  <td className='bx-finance__col-investor'>
                    {asset.createdByUser
                      ? `${asset.createdByUser.firstName} ${asset.createdByUser.lastName}`
                      : asset.createdByAccountId || '-'}
                  </td>
                  <td className='bx-finance__col-amount'>
                    ₦{CurrencyFormatter(Number(asset.principalNairaMajor ?? 0))}
                  </td>
                  <td className='bx-finance__col-date'>
                    {asset.purchaseDate ? new Date(asset.purchaseDate).toLocaleString() : '-'}
                  </td>
                  <td className='bx-finance__col-amount'>
                    {asset.nextPayoutDueAt ? new Date(asset.nextPayoutDueAt).toLocaleString() : '-'}
                  </td>
                  <td className='bx-finance__col-status'>
                    <span
                      className={`bx-status-pill bx-status-pill--${asset.status?.toLowerCase()}`}
                    >
                      {asset.status || 'ACTIVE'}
                    </span>
                  </td>
                  <td className='bx-finance__col-pool'>TGT 112581</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={7} className='bx-finance__empty'>
                No investments found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default TdlaInvestmentsTable
